import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  setSimple: {
    width: 100,
    height: 100,
    d: `M50,2.507C23.77,2.507,2.507,23.77,2.507,50S23.77,97.493,50,97.493S97.493,76.23,97.493,50
  		S76.23,2.507,50,2.507z M81.273,51.629c0,1.648-1.336,2.984-2.984,2.984H54.613v23.676c0,1.648-1.336,2.984-2.984,2.984h-3.257
  		c-1.648,0-2.984-1.336-2.984-2.984V54.613H21.711c-1.648,0-2.984-1.336-2.984-2.984v-3.257c0-1.648,1.336-2.984,2.984-2.984h23.676
  		V21.711c0-1.648,1.336-2.984,2.984-2.984h3.257c1.648,0,2.984,1.336,2.984,2.984v23.677h23.676c1.648,0,2.984,1.336,2.984,2.984
  		V51.629z`,
  },
});
